/**
 * Client Component to manage backend JWT token
 * Retrieves token from NextAuth session and stores it for API calls
 */

'use client'

import { useBackendToken } from '@/hooks/useBackendToken'

const BackendTokenManager = () => {
  useBackendToken()
  return null // This component doesn't render anything
}

export default BackendTokenManager

